import type { NotificationCadence, NotificationCategory, QuietHours } from '@yawi/types';
import type { NotificationChannel, NotificationPriority, NotificationType } from './INotificationRepository';

export interface NotificationConfig {
  type: NotificationType;
  enabled: boolean;
  channels: NotificationChannel[];
  cadence: NotificationCadence;
  priority: NotificationPriority;
  quietHours: QuietHours | null;
  updatedAt: string;
}

export const CATEGORY_TO_TYPES: Record<NotificationCategory, NotificationType[]> = {
  reservations: ['RESERVATION_CREATED', 'RESERVATION_CONFIRMED', 'RESERVATION_CANCELLED', 'RESERVATION_REMINDER_24H', 'RESERVATION_REMINDER_2H', 'DEPOSIT_REFUNDED', 'DEPOSIT_DEDUCTED', 'AMENITY_CREATED', 'AMENITY_MAINTENANCE_SCHEDULED'],
  payments: ['PAYMENT_CREATED', 'PAYMENT_REMINDER_5D', 'PAYMENT_REMINDER_DUE', 'PAYMENT_OVERDUE', 'PROOF_RECEIVED', 'PAYMENT_VERIFIED', 'PAYMENT_REJECTED', 'INVOICE_GENERATED', 'CHARGE_CANCELLED'],
  tickets: ['TICKET_CREATED', 'TICKET_ASSIGNED', 'TICKET_STATUS_CHANGED', 'TICKET_COMMENT_ADMIN', 'TICKET_COMMENT_USER', 'TICKET_RESOLVED', 'TICKET_SLA_WARNING', 'TICKET_REOPENED'],
  announcements: ['ANNOUNCEMENT_INFO', 'ANNOUNCEMENT_IMPORTANT', 'ANNOUNCEMENT_URGENT', 'ANNOUNCEMENT_EVENT', 'EVENT_REMINDER'],
  access: ['DEVICE_OFFLINE', 'DEVICE_ONLINE', 'RESTRICTION_APPLIED', 'RESTRICTION_RESOLVED', 'UNIT_MEMBER_ASSIGNED', 'UNIT_MEMBER_REMOVED'],
  guests: ['GUEST_ARRIVED', 'GUEST_DELETED', 'INVITATION_CREATED', 'INVITATION_EXPIRING', 'INVITATION_USED'],
  pets: ['VACCINE_EXPIRING', 'VACCINE_EXPIRED', 'PET_LOST_REPORTED', 'PET_FOUND', 'PET_REGISTERED'],
  documents: ['DOCUMENT_UPLOADED', 'GDPR_EXPORT_READY'],
  polls: ['POLL_RESULTS_PUBLISHED', 'POLL_ABOUT_TO_CLOSE'],
  security: ['USER_WELCOME', 'USER_BLOCKED', 'USER_UNBLOCKED', 'PASSWORD_CHANGED', 'NEW_DEVICE_LOGIN', 'ACCESS_DENIED_BLACKLIST', 'USER_ROLE_CHANGED', 'USER_ACCOUNT_DEACTIVATED', 'HOUSEHOLD_MEMBER_ADDED', 'HOUSEHOLD_MEMBER_REMOVED', 'VEHICLE_REGISTERED', 'VEHICLE_DEACTIVATED'],
};

export interface INotificationConfigRepository {
  list(): Promise<NotificationConfig[]>;
  getByType(type: NotificationType): Promise<NotificationConfig | null>;
  update(type: NotificationType, patch: Partial<Omit<NotificationConfig, 'type' | 'updatedAt'>>): Promise<NotificationConfig>;
  bulkUpdate(updates: Array<{ type: NotificationType } & Partial<Omit<NotificationConfig, 'updatedAt'>>>): Promise<NotificationConfig[]>;
  resetToDefaults(): Promise<NotificationConfig[]>;
}
